import { render, staticRenderFns } from "./ArticleKitPricingSummary.vue?vue&type=template&id=01b16bcc&"
import script from "./ArticleKitPricingSummary.vue?vue&type=script&lang=js&"
export * from "./ArticleKitPricingSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports